import { MatSnackBar } from '@angular/material';
import { Result } from './result.model';
import { SweetalertComponent } from '../sweetalert/sweetalert.component';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ModuloPersonal, ModuloUsuario, UsuarioPersonal } from 'src/app/projects/personal/accesos/accesos-class/accesos.model';

export class Parent {

  public fromDate: NgbDate;
  public showProcessing: Boolean = false;
  public showOpacity: Boolean = false;
  public success_access: boolean = false;
  public operationNew = 'NUEVO';
  public operationDelete = 'ELIMINAR';
  public operationUpdate = 'MODIFICAR';
  public operationView = 'VER';
  public obreros_rj = 1;
  public inversion = 2;
  public cas = 3;
  public obreros = 4;
  public pensionistas = 5;
  public nombrados = 6;
  public consejeros = 7;
  public apoyo_alimentario = 8;
  public cafae = 9;
  public pagos_adicionales = 10;
  /* ===DATOS DE ACCESO DE USUARIO=== */
  public listModulosPersonal: Array<ModuloUsuario> = [];
  public listUsuariosOficinas: Array<any> = [];
  public listUsuariosMetas: Array<any> = [];
  public soloLectura: boolean = false;
  public usuario: UsuarioPersonal;
  /*=== ESTADO DE TAREOS ===*/
  public tareoElaborado = -1;
  public tareoEnviado = 0;
  public tareoAprobado = 1;
  /**=======ATRIBUTOS TABS============ */
  public classTab1 = 'nav-link active';
  public classTab2 = 'nav-link';
  public classTab3 = 'nav-link';
  public classTab4 = 'nav-link';
  public classTab5 = 'nav-link';
  public classTab6 = 'nav-link';

  public activeTab1 = true;
  public activeTab2 = false;
  public activeTab3 = false;
  public activeTab4 = false;
  public activeTab5 = false;
  public activeTab6 = false;
  /**================================= */

  public mensajePopup = new SweetalertComponent();

  message(snackBar: MatSnackBar, message: string, code: string) {
    snackBar.open(message, code, {
      duration: 5000,
      horizontalPosition: 'center'
    });
  }

  showResult(snackBar: MatSnackBar, result: Result) {
    if (result.success) {
      snackBar.open('Procesado correctamente', 'OK', {
        duration: 5000,
        horizontalPosition: 'end'
      });
    } else {
      snackBar.open(result.msg, 'ERROR', {
        duration: 5000,
        horizontalPosition: 'end'
      });
    }
  }

  showErrorUnexpected(snackBar: MatSnackBar) {
    snackBar.open('SERVER ERROR', 'ERROR', {
      duration: 5000
    });
  }

  blobToFile(theBlob: Blob, fileName: string): File {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Cast to a File() type
    return <File>theBlob;
  }

  getDateYMD(date): string {
    return date.year + '-' + date.month + '-' + date.day;
  }

  ngbDateToYMD(date: NgbDate): string {
    let dateYMD = date.year + '-';
    if (date.month < 10) dateYMD += '0' + date.month + '-';
    else dateYMD += date.month + '-';
    if (date.day < 10) dateYMD += '0' + date.day;
    else dateYMD += date.day;
    return dateYMD;
  }

  stringYMDToNgbDate(date: string): NgbDate {
    return date ? <NgbDate>{
      year: Number(date.substring(0, 4)),
      month: Number(date.substring(5, 7)),
      day: Number(date.substring(8, 10))
    } : null;
  }

  validar_acceso(modulo: string, ruta: string) {
    this.success_access = JSON.parse(localStorage.getItem('uid'));
    if (!this.success_access) {
      this.showOpacity = true;
      window.location.href = '/login';
    }
    /* else if(this.router.url === ruta){
      this.showOpacity = true;
      window.location.href = '/home';
    } */
  }

  activarTab(option: number) {
    if (option === 1) {
      this.classTab1 = 'nav-link active';
      this.classTab2 = 'nav-link';
      this.classTab3 = 'nav-link';
      this.classTab4 = 'nav-link';
      this.classTab5 = 'nav-link';
      this.classTab6 = 'nav-link';

      this.activeTab1 = true;
      this.activeTab2 = false;
      this.activeTab3 = false;
      this.activeTab4 = false;
      this.activeTab5 = false;
      this.activeTab6 = false;
    } else if (option === 2) {
      this.classTab1 = 'nav-link';
      this.classTab2 = 'nav-link active';
      this.classTab3 = 'nav-link';
      this.classTab4 = 'nav-link';
      this.classTab5 = 'nav-link';
      this.classTab6 = 'nav-link';

      this.activeTab1 = false;
      this.activeTab2 = true;
      this.activeTab3 = false;
      this.activeTab4 = false;
      this.activeTab5 = false;
      this.activeTab6 = false;
    } else if (option === 3) {
      this.classTab1 = 'nav-link';
      this.classTab2 = 'nav-link';
      this.classTab3 = 'nav-link active';
      this.classTab4 = 'nav-link';
      this.classTab5 = 'nav-link';
      this.classTab6 = 'nav-link';

      this.activeTab1 = false;
      this.activeTab2 = false;
      this.activeTab3 = true;
      this.activeTab4 = false;
      this.activeTab5 = false;
      this.activeTab6 = false;
    } else if (option === 4) {
      this.classTab1 = 'nav-link';
      this.classTab2 = 'nav-link';
      this.classTab3 = 'nav-link';
      this.classTab4 = 'nav-link active';
      this.classTab5 = 'nav-link';
      this.classTab6 = 'nav-link';

      this.activeTab1 = false;
      this.activeTab2 = false;
      this.activeTab3 = false;
      this.activeTab4 = true;
      this.activeTab5 = false;
      this.activeTab6 = false;
    } else if (option === 5) {
      this.classTab1 = 'nav-link';
      this.classTab2 = 'nav-link';
      this.classTab3 = 'nav-link';
      this.classTab4 = 'nav-link';
      this.classTab5 = 'nav-link active';
      this.classTab6 = 'nav-link';

      this.activeTab1 = false;
      this.activeTab2 = false;
      this.activeTab3 = false;
      this.activeTab4 = false;
      this.activeTab5 = true;
      this.activeTab6 = false;
    } else if (option === 6) {
      this.classTab1 = 'nav-link';
      this.classTab2 = 'nav-link';
      this.classTab3 = 'nav-link';
      this.classTab4 = 'nav-link';
      this.classTab5 = 'nav-link';
      this.classTab6 = 'nav-link active';

      this.activeTab1 = false;
      this.activeTab2 = false;
      this.activeTab3 = false;
      this.activeTab4 = false;
      this.activeTab5 = false;
      this.activeTab6 = true;
    }
  }

  mesTexto(mes: number) {
    let texto = '';
    switch (mes) {
      case 1: texto = 'ENERO'; break;
      case 2: texto = 'FEBRERO'; break;
      case 3: texto = 'MARZO'; break;
      case 4: texto = 'ABRIL'; break;
      case 5: texto = 'MAYO'; break;
      case 6: texto = 'JUNIO'; break;
      case 7: texto = 'JULIO'; break;
      case 8: texto = 'AGOSTO'; break;
      case 9: texto = 'SETIEMBRE'; break;
      case 10: texto = 'OCTUBRE'; break;
      case 11: texto = 'NOVIEMBRE'; break;
      case 12: texto = 'DICIEMBRE'; break;
      default: texto = '';
    }
    return texto;
  }
}
